import { render, staticRenderFns } from "./Recreation.vue?vue&type=template&id=6c396a57&scoped=true&"
import script from "./Recreation.vue?vue&type=script&lang=js&"
export * from "./Recreation.vue?vue&type=script&lang=js&"
import style0 from "./Recreation.vue?vue&type=style&index=0&id=6c396a57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c396a57",
  null
  
)

export default component.exports